import { createBehavior } from '@area17/a17-behaviors';

const PATTERN_WIDTH = 98;
const PATTERN_HEIGHT = 147;

const patternSvg = createBehavior(
  'pattern-svg',
  {
    updateRowCountFromCss() {
      // Columns
      this.cols = null;
      const colVar = getComputedStyle(this.$node).getPropertyValue(
        '--pattern-cols'
      );
      if (colVar) {
        this.cols = parseInt(colVar, 10);
      }

      this.rows = parseInt(
        getComputedStyle(this.$node).getPropertyValue('--pattern-rows') ?? 1,
        10
      );
    },
    updateWidth() {
      this.width = this.$sensor.getBoundingClientRect().width;
    },
    handleWindowResize() {
      this.updateRowCountFromCss();
      this.updateWidth();
      this.render();
    },
    render() {
      this.$inner.innerHTML = '';

      this.draw = this.SVG().addTo(this.$inner);
      this.$patternTemplate = this.SVG(this.svgTemplateId);

      const colCount =
        this.cols ?? Math.max(5, Math.floor(this.width / PATTERN_WIDTH));

      const height = this.rows * PATTERN_HEIGHT;
      const width = colCount * PATTERN_WIDTH;
      const scale = this.width / width;

      this.$inner.style.height = `${this.width * (height / width)}px`;

      const group = this.draw.group();
      group.scale(scale, 0, 0);

      let i = 0;
      for (let row = 0; row < this.rows; row++) {
        for (let col = 0; col < colCount; col++) {
          const pattern = this.draw.use(this.$patternTemplate);
          pattern.x(PATTERN_WIDTH * col);
          pattern.y(PATTERN_HEIGHT * row);
          pattern.node.style.setProperty(
            '--fill',
            i % 2 ? 'var(--first-fill)' : 'var(--second-fill)'
          );
          pattern.addTo(group);
          i++;
        }
      }
    },
  },
  {
    init() {
      this.$inner = this.$node.querySelector('[data-patternsvg-inner]');
      this.$sensor = this.$node.querySelector('[data-patternsvg-sensor]');
      this.svgTemplateId = '#pattern';

      (async () => {
        const { SVG } = await import('@svgdotjs/svg.js');
        this.SVG = SVG;

        this.observer = new ResizeObserver((entries) => {
          for (let entry of entries) {
            this.width = parseInt(entry.contentRect.width, 10);
            this.render();
          }
        });
        this.observer.observe(this.$sensor);

        window.addEventListener('resize', this.handleWindowResize);
        this.updateRowCountFromCss();
        this.updateWidth();

        this.render();
      })();
    },
    destroy() {
      window.removeEventListener('resize', this.handleWindowResize);
      this.observer.unobserve(this.$sensor);
    },
  }
);

export default patternSvg;
